import React from 'react'
import ScaleLoader from "react-spinners/ScaleLoader";

import './PageLoader.css'

function PageLoader() {
  return (
    <div className="pageLoader">
      <ScaleLoader color="#0C2340" loading={true} size={150} />
    </div>
  )
}

export default PageLoader